import type { RouteLocationNormalized } from 'vue-router';
import { ScrollTopPadding } from '@/constants';
import { getHeaderHeightInPx } from '@/utils/headerHeight';

function determineMarginFromPageTop() {
  // need to add the scroll height of the header plus a small padding
  const MarginFromPageTop = getHeaderHeightInPx() + ScrollTopPadding;

  /**
   * The if condition part has been added to override default scroll behaviour for API Documentation Page.
   * and subtracting apiDocsNavigationElement.offsetHeight, HeaderHeight  is giving correct position of the element
   * after scrolling.
   * */
  const apiDocsNavigationElement = document.getElementById('api-docs-navigation');
  if (apiDocsNavigationElement) {
    return apiDocsNavigationElement.offsetHeight + MarginFromPageTop;
  }
  return MarginFromPageTop;
}
export function scrollToElement(element: HTMLElement | null, behavior: ScrollBehavior = 'auto') {
  // scroll to anchor if it exists
  if (element) {
    window.scrollTo({ left: 0, top: element.getBoundingClientRect().top - determineMarginFromPageTop(), behavior });
  }
}

export function scrollToElementHash(hash: string, behavior: ScrollBehavior = 'auto') {
  scrollToElement(document.getElementById(decodeURIComponent(hash.substring(1))), behavior);
}

export function scrollBehavior(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  if (to.hash) {
    const el = document.getElementById(decodeURIComponent(to.hash.substring(1)));
    if (!el) {
      return false;
    }
    return {
      el: decodeURIComponent(to.hash),
      left: 0,
      top: determineMarginFromPageTop(),
      behavior: 'smooth',
    };
  }
  if (to.path === from.path) {
    return null;
  }
  return { top: 0, behavior: 'smooth' };
}
